import script from "./Verso.vue?vue&type=script&setup=true&lang=js"
export * from "./Verso.vue?vue&type=script&setup=true&lang=js"

import "./Verso.vue?vue&type=style&index=0&id=dbf84598&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dbf84598"]])

export default __exports__